import React, { useEffect, useRef } from "react";
import "./TestimonialsSection.css";

const testimonials = [
  {
    text: '“We have known Abhinav Bakiwala for several years and have consistently found his approach to be disciplined, practical, and client-focused. His support in equity and mutual fund investments is well-researched and aligned with long-term wealth creation. He explains financial concepts with clarity and professionalism. We recommend Wealth Compounders for structured and reliable financial solutions.”',
    name: "Partner, ABAP & Company",
    role: "Chartered Accountants",
  },
  {
    text: '“I was introduced to Abhinav Bakiwala for investment and portfolio support and have been impressed by his strong understanding of financial planning and long-term wealth management. He takes personal interest in his clients’ financial well-being and offers solutions that are simple, transparent, and effective. His support has brought clarity and confidence to our financial decisions.”',
    name: "Dr. Ashok Khandaka",
    role: "Khandaka Hospital",
  },
  {
    text: '“We engaged with Abhinav Bakiwala and were extremely satisfied with his professionalism and dedication. He has deep knowledge of financial markets and takes personal interest in understanding business requirements despite his busy schedule. His clarity, commitment, and passion truly stand out. We strongly recommend Wealth Compounders.”',
    name: "Anshuman Pareek",
    role: "United Fabricators",
  },
  {
    text: '“I worked with Abhinav Bakiwala and was completely satisfied with the experience. He has strong knowledge of financial planning and always prioritizes the client’s best interest. His approach is practical, timely, and easy to understand. I admire his dedication and passion and would strongly recommend Wealth Compounders.”',
    name: "Nitin Taluka",
    role: "Taluka Jewels",
  },
  {
    text: '“Managing finances alongside running a creative business can be challenging. Abhinav Bakiwala helped us structure our investments efficiently and manage surplus funds better. His approach is honest, practical, and easy to understand. Working with Wealth Compounders has made financial management simple and stress-free.”',
    name: "Director",
    role: "Creative Movies",
  },
  {
    text: '“I have been associated with Abhinav Bakiwala for financial planning and investment support, and my experience has been very positive. His approach towards wealth management is systematic, transparent, and based on long-term vision rather than short-term market movements. He takes time to understand individual requirements and helps structure investments accordingly.”',
    name: "Amit Mathur",
    role: "Mangalam Hospital",
  },
];

const TestimonialsSection = () => {
  const revealRef = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("show"),
        ),
      { threshold: 0.1 },
    );
    if (revealRef.current) obs.observe(revealRef.current);
    return () => obs.disconnect();
  }, []);

  const onTilt = (e, card) => {
    const r = card.getBoundingClientRect();
    const rx = (e.clientY - r.top - r.height / 2) / 20;
    const ry = (r.width / 2 - (e.clientX - r.left)) / 20;
    card.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-10px) translateZ(0)`;
  };

  const onTiltLeave = (e, card) => {
    card.style.transform = "";
  };

  return (
    <section className="wc-ui-testimonials-section">
      <div
        className="wc-ui-testimonials-container wc-ui-reveal"
        ref={revealRef}
      >
        <h2 className="wc-ui-testimonials-title" id="wc-ui-testimony">
          What Our Clients Are{" "}
          <span className="wc-ui-gradient-text">Saying</span>
        </h2>
        <p className="wc-ui-testimonials-subtitle">
          Don't just take our word for it. Hear from real clients who've
          transformed their financial future with us.
        </p>
        <div className="wc-ui-testimonials-grid">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="wc-ui-testimonial-card"
              onMouseMove={(e) => onTilt(e, e.currentTarget)}
              onMouseLeave={(e) => onTiltLeave(e, e.currentTarget)}
            >
              <div className="wc-ui-testimonial-stars">
                {[...Array(5)].map((_, s) => (
                  <i key={s} className="fas fa-star"></i>
                ))}
              </div>
              <p className="wc-ui-testimonial-text">{t.text}</p>
              <div className="wc-ui-testimonial-footer">
                <div className="wc-ui-testimonial-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div>
                  <h4 className="wc-ui-testimonial-name">{t.name}</h4>
                  <p className="wc-ui-testimonial-role">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
